import { httpV2 } from "@/api";

/**
 * Deleta um evento de manutenção.
 * @param {number} eventId Id do evento.
 */
const DeleteEvent = function(eventId)
{
	return httpV2.delete(`/MaintenanceEvent/${eventId}/MaintenanceEventRecord`);
};

/**
 * Solicita os eventos de manutenção mais recentes cadastrados para esta turbina.
 * @param {number} eventId Parâmetros da requisição.
 */
const DownloadEvent = function(eventId)
{
	const configuration = { responseType: "blob" };
	return httpV2.get(`MaintenanceEvent/${eventId}/DownloadMaintenanceEventFile`, configuration);
};

export default
{
	DeleteEvent,
	DownloadEvent
};